import { render } from "./MMiniAppEditModal.vue?vue&type=template&id=50d28dbb&scoped=true&ts=true"
import script from "./MMiniAppEditModal.vue?vue&type=script&lang=ts"
export * from "./MMiniAppEditModal.vue?vue&type=script&lang=ts"

import "./MMiniAppEditModal.vue?vue&type=style&index=0&id=50d28dbb&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d28dbb"]])

export default __exports__